import Store from "../../../Store";
import "./HomePage.css";
import woman from "../../../common/assets/woman.png";
import { useState } from "react";
import LoginModal from "../../components/Modals/LoginModal/LoginModal";
import HomepageButton from "../../components/Buttons/HomepageButton/HomepageButton";
import RegisterModal from "../../components/Modals/RegisterModal/RegisterModal";
import PasswordRecoveryModal from "../../components/Modals/PasswordRecoveryModal/PasswordRecoveryModal";
import ChangePasswordHomeModal from "../../components/Modals/ChangePasswordHomeModal/ChangePasswordHomeModal";
import usePropState from "../../common/hook/usePropState";
import useSetTags from "../../../product/hooks/useSetTags";

const CONFIG = {
  cz: {
    title: "eLingo – Mluv směleji, sebevědoměji",
    description:
      "Zlepši své jazykové dovednosti s praktickými kurzy. Jazykový kurz eLingo ti pomůže k úspěchu. Připoj se k eLingu a využij jeho výhod!",
  },
  cs: {
    title: "eLingo – Mluv směleji, sebevědoměji",
    description:
      "Zlepši své jazykové dovednosti s praktickými kurzy. Jazykový kurz eLingo ti pomůže k úspěchu. Připoj se k eLingu a využij jeho výhod!",
  },
  hu: {
    title: "eLingo – Beszélj merészebben, magabiztosabban",
    description:
      "Javítsd nyelvi készségeidet gyakorlati tanfolyamokkal. Az eLingo nyelvi tanfolyam segít sikeressé válni. Csatlakozz az eLingóhoz és profitálj belőle!",
  },
  en: {
    title: "eLingo – Speak more boldly, confidently",
    description:
      "Boost your language skills with practical courses. The eLingo language course will help you succeed. Join eLingo and benefit!",
  },
  sk: {
    title: "eLingo jazykové kurzy | Názory a recenzie platformy",
    description:
      "Zistite všetko o eLingo: metóda výučby a výhody kurzov. Tisíce spokojných študentov. Pridajte sa k eLingo a využite výhody!",
  },
  lt: {
    title: "eLingo – Kalbėk drąsiau, pasitikėdamas savimi",
    description:
      "Patobulink savo kalbos įgūdžius praktiškuose kursuose. eLingo kalbų kursas padės siekti sėkmės. Prisijunk prie eLingo ir pasinaudok privalumais!",
  },
  hr: {
    title: "eLingo – Govori smjelije, samopouzdanije",
    description:
      "Unaprijedi svoje jezične vještine praktičnim tečajevima. Jezični tečaj eLingo pomoći će ti uspjeti. Pridruži se eLingu i iskoristi prednosti!",
  },
  ro: {
    title: "eLingo – Vorbește mai îndrăzneț, mai încrezător",
    description:
      "Îmbunătățește-ți abilitățile lingvistice cu cursuri practice. Cursul de limbă eLingo te va ajuta să reușești. Alătură-te eLingo și beneficiază!",
  },
  lv: {
    title: "eLingo | Droši runājiet jebkurā valodā!",
    description: "Uzlabojiet savas valodas prasmes ar praktiskiem kursiem. eLingo valodas kurss palīdzēs jums panākt panākumus. Pievienojieties eLingo un izmantojiet tā priekšrocības!",
  },
  pl: {
    title: "eLingo - Mów odważniej, pewniej siebie",
    description: "Zwiększ swoje umiejętności językowe dzięki praktycznym kursom. Kurs językowy eLingo pomoże Ci odnieść sukces. Dołącz do eLingo i korzystaj!",
  },
  bg: {
    title: "eLingo езикови курсове | Мнения и рецензии за платформата",
    description: "Научете всичко за eLingo: метод на обучение и предимства на курсовете. Хиляди доволни cursанти. Присъединете се към eLingo и се възползвайте!",
  },
  sl: {
    title: "Prijava ali registracija – račun eLingo",
    description: "Izvedite vse o eLingu: metoda učenja in prednosti tečajev. Pridružite se eLingu in izkoristite prednosti! Resnični rezultati v kratkem času.",
  }
};

function HomePage({
  setError,
  isInitPasswordRecoveryModalOpen,
  isInitChangePasswordModalOpen,
}) {
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);
  const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] =
    usePropState(isInitChangePasswordModalOpen);
  const [isPasswordRecoveryModalOpen, setIsPasswordRecoveryModalOpen] =
    usePropState(isInitPasswordRecoveryModalOpen);

  useSetTags(CONFIG);

  return (
    <div className="home-page">
      {isLoginModalOpen && (
        <LoginModal
          isModalOpen={isLoginModalOpen}
          setIsModalOpen={setIsLoginModalOpen}
          setError={setError}
        />
      )}
      {isRegisterModalOpen && (
        <RegisterModal
          isModalOpen={isRegisterModalOpen}
          setIsModalOpen={setIsRegisterModalOpen}
          setError={setError}
        />
      )}
      {isPasswordRecoveryModalOpen && (
        <PasswordRecoveryModal
          isModalOpen={isPasswordRecoveryModalOpen}
          setIsModalOpen={setIsPasswordRecoveryModalOpen}
          setError={setError}
        />
      )}
      {isChangePasswordModalOpen && (
        <ChangePasswordHomeModal
          isModalOpen={isChangePasswordModalOpen}
          setIsModalOpen={setIsChangePasswordModalOpen}
          setError={setError}
        />
      )}
      <h2 className="home-page__header">
        <span className="home-page__header--bold">
          {Store.getText("homePageSloganFirstLine", true)}
        </span>{" "}
        {Store.getText("homePageSloganSecondLine", true)}
      </h2>
      <div className="home-page__boxes">
        <div className="home-page__box">
          <h3 className="home-page__box-header">
            {Store.getText("login", true)}
          </h3>
          <p className="home-page__box-text">
            {Store.getText("loginBoxDescription", true)}
          </p>
          <HomepageButton
            className="home-page__box-button"
            onClick={() => setIsLoginModalOpen(true)}
          >
            {Store.getText("loginButtonText", true)}
          </HomepageButton>
        </div>

        <div className="home-page__box home-page__box--transparent">
          <h3 className="home-page__box-header">
            {Store.getText("register", true)}
          </h3>
          <p className="home-page__box-text">
            {Store.getText("registerBoxDescription", true)}
          </p>
          <HomepageButton
            className="home-page__box-button"
            onClick={() => setIsRegisterModalOpen(true)}
          >
            {Store.getText("registerButtonText", true)}
          </HomepageButton>
        </div>
      </div>
      <div className="home-page__circle">
        <img src={woman} alt="woman" className="home-page__circle-image" />
      </div>
    </div>
  );
}

export default HomePage;
